__turbopack_context__.v({
  "active": "TableOfContents-module__53Nwva__active",
  "chevron": "TableOfContents-module__53Nwva__chevron",
  "chevronRotated": "TableOfContents-module__53Nwva__chevronRotated",
  "isExpanded": "TableOfContents-module__53Nwva__isExpanded",
  "level3": "TableOfContents-module__53Nwva__level3",
  "mobileCurrent": "TableOfContents-module__53Nwva__mobileCurrent",
  "mobileHeader": "TableOfContents-module__53Nwva__mobileHeader",
  "toc": "TableOfContents-module__53Nwva__toc",
  "tocContent": "TableOfContents-module__53Nwva__tocContent",
  "tocItem": "TableOfContents-module__53Nwva__tocItem",
  "tocLink": "TableOfContents-module__53Nwva__tocLink",
  "tocList": "TableOfContents-module__53Nwva__tocList",
});
